var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0074 18.75L10.9199 18.125L13.4199 13.75H17.1699C17.5014 13.75 17.8194 13.6183 18.0538 13.3839C18.2882 13.1495 18.4199 12.8315 18.4199 12.5V5C18.4199 4.66848 18.2882 4.35054 18.0538 4.11612C17.8194 3.8817 17.5014 3.75 17.1699 3.75H4.66992C4.3384 3.75 4.02046 3.8817 3.78604 4.11612C3.55162 4.35054 3.41992 4.66848 3.41992 5V12.5C3.41992 12.8315 3.55162 13.1495 3.78604 13.3839C4.02046 13.6183 4.3384 13.75 4.66992 13.75H10.2949V15H4.66992C4.00688 15 3.371 14.7366 2.90215 14.2678C2.43331 13.7989 2.16992 13.163 2.16992 12.5V5C2.16992 4.33696 2.43331 3.70107 2.90215 3.23223C3.371 2.76339 4.00688 2.5 4.66992 2.5H17.1699C17.833 2.5 18.4688 2.76339 18.9377 3.23223C19.4065 3.70107 19.6699 4.33696 19.6699 5V12.5C19.6699 13.163 19.4065 13.7989 18.9377 14.2678C18.4688 14.7366 17.833 15 17.1699 15H14.1449L12.0074 18.75Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91992 6.25H15.9199V7.5H5.91992V6.25ZM5.91992 10H12.1699V11.25H5.91992V10Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.c45ada13d80a58a732382881e561ac60.svg";
export { ForwardRef as ReactComponent };